var BeethovenFrieze = (function(root_url) {
  var generateServiceUrl, sendMessage, image_selected_callbacks, on_complete_callbacks, services, tray_image_removed_callbacks, on_album_entry_callbacks;

  services = {
    instagram: 'instagram',
    picasa: 'picasa',
  };

  image_selected_callbacks = [];

  on_complete_callbacks = [];

  tray_image_removed_callbacks = [];

  on_album_entry_callbacks = [];

  (function() {
    var MessageHandler, messageHandlers, messageReceived, onCompleteMessage, onImageSelectedMessage, onTrayImageRemoved, onAlbumEntry;
    MessageHandler = (function() {
      function MessageHandler(prefix, onRecieved) {
        this.prefix = prefix;
        this.onRecieved = onRecieved;
      }

      MessageHandler.prototype.is = function(message) {
        return message.match(this.prefix);
      };

      MessageHandler.prototype.strip = function(message) {
        return message.replace(this.prefix, '');
      };

      MessageHandler.prototype.handle = function(message) {
        if (typeof message === 'string' && this.is(message)) {
          return this.onRecieved(this.strip(message));
        }
      };

      return MessageHandler;
    })();
    onImageSelectedMessage = function(data) {
      var i, image_selected_callback, len;
      data = (function() {
        try {
          return JSON.parse(data);
        } catch (error) {
          return {
            url: data
          };
        }
      })();
      for (i = 0, len = image_selected_callbacks.length; i < len; i++) {
        image_selected_callback = image_selected_callbacks[i];
        image_selected_callback({ url: data.url, thumb: data.thumb, filename: data.displayName, originalKey: data.originalKey, foreignUserId: data.id });
      }
      return void 0;
    };
    onCompleteMessage = function() {
      var i, len, on_complete_callback;
      for (i = 0, len = on_complete_callbacks.length; i < len; i++) {
        on_complete_callback = on_complete_callbacks[i];
        on_complete_callback();
      }
      return void 0;
    };

    onTrayImageRemoved = function(data) {
      data = (function() {
        try {
          return JSON.parse(data);
        } catch (error) {
          return {
            url: data
          };
        }
      })();
      var i, len, tray_image_removed_callback;
      for (i = 0, len = tray_image_removed_callbacks.length; i < len; i++) {
        tray_image_removed_callback = tray_image_removed_callbacks[i];
        tray_image_removed_callback(data);
      }
      return void 0;
    };

    onAlbumEntry = function(data) {
      data = (function() {
        try {
          return data;
        } catch (error) {
          return {
            url: data
          };
        }
      })();
      var i, len, on_album_entry_callback;
      for (i = 0, len = on_album_entry_callbacks.length; i < len; i++) {
        on_album_entry_callback = on_album_entry_callbacks[i];
        on_album_entry_callback(data);
      }
      return void 0;
    };

    messageHandlers = [new MessageHandler(/^image_selected:/, onImageSelectedMessage), new MessageHandler(/^complete$/, onCompleteMessage), new MessageHandler(/^tray_image_removed:/, onTrayImageRemoved), new MessageHandler(/^on_album_entry:/, onAlbumEntry)];
    messageReceived = function(e) {
      var i, len, messageHandler;
      if (e.origin === root_url) {
        for (i = 0, len = messageHandlers.length; i < len; i++) {
          messageHandler = messageHandlers[i];
          messageHandler.handle(e.data);
        }
      }
      return void 0;
    };
    return window.addEventListener("message", messageReceived, false);
  })();

  generateServiceUrl = function(service, params, single_image_select) {
    var generateUrl, url;
    if (single_image_select == null) {
      single_image_select = true;
    }
    if (!services[service]) {
      return;
    }
    generateUrl = function(url, params) {
      var param, value;
      if (params == null) {
        params = {};
      }
      return (url + "?") + ((function() {
        var results;
        results = [];
        for (param in params) {
          value = params[param];
          if (value) {
            results.push(param + "=" + (param === 'callback' ? value : encodeURIComponent(value)));
          }
        }
        return results;
      })()).join('&');
    };
    params.service = service;
    params.source_url = window.location.href.replace(/#.*$/, '');
    params.single_image_select = single_image_select;
    params.live_update = true;
    return url = generateUrl(root_url + "/login", params);
  };

  sendMessage = function(iFrame, message) {
    iFrame.contentWindow.postMessage(message, iFrame.src);
  };

  return {
    services: services,
    generateServiceUrl: generateServiceUrl,
    sendMessage: sendMessage,
    onImageSelected: function(callback) {
      return image_selected_callbacks.push(callback);
    },
    onComplete: function(callback) {
      return on_complete_callbacks.push(callback);
    },
    onTrayImageRemoved: function(callback) {
      return tray_image_removed_callbacks.push(callback);
    },
    onAlbumEntry: function(callback) {
      return on_album_entry_callbacks.push(callback);
    }
  };

}).call(this, window.cloudloader_url);

// 'http://192.168.148.4:3000'
// 'http://localhost:3000'
// 'https://cloudloader-wm.livelink.io'

// module.exports = BeethovenFrieze;
export default BeethovenFrieze;
